import { Reveal } from "@/components/Reveal";
import { IMAGES } from "@/lib/site";

const FOUNDER_PORTRAIT =
  "https://static.prod-images.emergentagent.com/jobs/9249dba4-f346-4ac7-85f0-bab7ca698c03/images/b2e3bd7e885805b09653e646d2f4cebdad6ec24c60e2d39519f9c17272f57694.jpeg";

const PARAGRAPHS = [
  "I started NGCONDE the way a lot of honest South African businesses start — with one bakkie, a phone that never switched off, and a promise that whatever was on the back would get there.",
  "I did the runs myself. That's where I learned what operations and procurement teams actually need: someone who answers the phone, a vehicle that shows up on time, and paperwork that comes back the same day. That is still the standard we hire for, dispatch by and grow by.",
  "Today, NGCONDE provides contracted parcel delivery and bakkie transport capacity for courier companies, e-commerce businesses, retailers, warehouses and corporates across the country. The fleet is bigger and the routes are longer — the promise hasn't changed.",
];

export const Founder = () => (
  <section className="border-y border-white/10 bg-[#0D1424] py-20 md:py-28" data-testid="founder-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="relative mx-auto max-w-sm lg:max-w-none" data-testid="founder-portrait">
              <div
                className="absolute -inset-2 rounded-3xl border border-[#FF6B00]/30"
                aria-hidden="true"
              />
              <img
                src={FOUNDER_PORTRAIT}
                alt="Abongile Goci, Founder and CEO of NGCONDE Courier Service"
                loading="lazy"
                className="relative aspect-[3/4] w-full rounded-2xl border border-white/10 object-cover"
              />
              <div className="absolute bottom-4 left-4 right-4 rounded-xl border border-white/10 bg-[#080C14]/85 px-4 py-3 backdrop-blur">
                <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.22em] text-[#FF6B00]">
                  Founder &amp; CEO
                </p>
                <p className="mt-0.5 font-display text-lg font-extrabold uppercase tracking-tight text-white">
                  Abongile Goci
                </p>
              </div>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal>
            <p className="flex items-center gap-3 font-mono text-xs font-semibold uppercase tracking-[0.25em] text-[#FF6B00]">
              <span className="inline-block h-px w-8 bg-[#FF6B00]" aria-hidden="true" />
              How It Started
            </p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-4 font-display text-3xl font-black uppercase leading-[1.02] tracking-tight text-white sm:text-4xl lg:text-5xl">
              One bakkie. One promise. <span className="text-stroke">Kept daily.</span>
            </h2>
          </Reveal>

          <div className="mt-7 space-y-5">
            {PARAGRAPHS.map((p, i) => (
              <Reveal key={i} delay={0.12 + i * 0.07}>
                <p className="max-w-2xl text-base leading-relaxed text-slate-300">{p}</p>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.3}>
            <div className="mt-9 border-t border-white/10 pt-6">
              <p className="font-display text-2xl font-black uppercase tracking-tight text-[#FF6B00]">
                Abongile Goci
              </p>
              <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.22em] text-slate-400">
                Founder &amp; CEO — NGCONDE Courier Service
              </p>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
